import styled from 'styled-components';

export const TopPaginationMenuStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 17px;
  border-bottom: 1px solid #cccccc;

  .total-count {
    font-size: 26px;
    white-space: nowrap;
  }

  .pagination-wrapper {
    display: flex;
    align-items: center;
  }

  .pagination {
    margin-left: 12px;

    label {
      width: 50px;
    }
  }

  @media screen and (max-width: 1080px) {
    .total-count {
      font-size: ${({ theme }) => theme.fontSize.xm};
    }
  }

  @media screen and (max-width: 1024px) {
    .pagination {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    .total-count {
      font-size: ${({ theme }) => theme.fontSize.md};
    }
  }

  @media screen and (max-width: 600px) {
    .total-count {
      margin-bottom: 12px;
    }
  }

  @media screen and (max-width: 512px) {
    padding-left: 10px;
    padding-right: 10px;

    .total-count {
      font-size: 15px;
    }
  }
`;

export const BottomPaginationMenuStyles = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 0px;
  padding-top: 17px;

  .pagination-wrapper {
    display: flex;
    align-items: center;
  }

  .pagination {
    margin-left: 0px;

    label {
      width: 50px;
    }
  }

  @media screen and (max-width: 512px) {
    padding: 7px;
  }

  @media screen and (max-width: 460px) {
    & [class*='PaginationStepHeader'] {
      display: none;
    }
  }
`;

export const DateOfAnnouncementBox = styled.div`
  width: 200px;
`;

export const LeftSide = styled.section`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const RigthSide = styled.section`
  display: flex;

  @media screen and (max-width: 600px) {
    align-self: flex-end;
  }
`;
